import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  DayOfWeek_MONDAY_instance = new (DayOfWeek())('MONDAY', 0);
  DayOfWeek_TUESDAY_instance = new (DayOfWeek())('TUESDAY', 1);
  DayOfWeek_WEDNESDAY_instance = new (DayOfWeek())('WEDNESDAY', 2);
  DayOfWeek_THURSDAY_instance = new (DayOfWeek())('THURSDAY', 3);
  DayOfWeek_FRIDAY_instance = new (DayOfWeek())('FRIDAY', 4);
  DayOfWeek_SATURDAY_instance = new (DayOfWeek())('SATURDAY', 5);
  DayOfWeek_SUNDAY_instance = new (DayOfWeek())('SUNDAY', 6);
}
var DayOfWeek_MONDAY_instance;
var DayOfWeek_TUESDAY_instance;
var DayOfWeek_WEDNESDAY_instance;
var DayOfWeek_THURSDAY_instance;
var DayOfWeek_FRIDAY_instance;
var DayOfWeek_SATURDAY_instance;
var DayOfWeek_SUNDAY_instance;
function values() {
  static_init();
  return [DayOfWeek_MONDAY_getInstance(), DayOfWeek_TUESDAY_getInstance(), DayOfWeek_WEDNESDAY_getInstance(), DayOfWeek_THURSDAY_getInstance(), DayOfWeek_FRIDAY_getInstance(), DayOfWeek_SATURDAY_getInstance(), DayOfWeek_SUNDAY_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var $ENTRIES;
var DayOfWeekClass;
function DayOfWeek() {
  if (DayOfWeekClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'DayOfWeek');
    DayOfWeekClass = $;
  }
  return DayOfWeekClass;
}
function get_isoDayNumber(_this__u8e3s4) {
  return _this__u8e3s4.ordinal_1 + 1 | 0;
}
function DayOfWeek_0(isoDayNumber) {
  // Inline function 'kotlin.require' call
  if (!(1 <= isoDayNumber ? isoDayNumber <= 7 : false)) {
    var message = 'Expected ISO day-of-week number in 1..7, got ' + isoDayNumber;
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return get_entries().get_c1px32_k$(isoDayNumber - 1 | 0);
}
function DayOfWeek_MONDAY_getInstance() {
  static_init();
  return DayOfWeek_MONDAY_instance;
}
function DayOfWeek_TUESDAY_getInstance() {
  static_init();
  return DayOfWeek_TUESDAY_instance;
}
function DayOfWeek_WEDNESDAY_getInstance() {
  static_init();
  return DayOfWeek_WEDNESDAY_instance;
}
function DayOfWeek_THURSDAY_getInstance() {
  static_init();
  return DayOfWeek_THURSDAY_instance;
}
function DayOfWeek_FRIDAY_getInstance() {
  static_init();
  return DayOfWeek_FRIDAY_instance;
}
function DayOfWeek_SATURDAY_getInstance() {
  static_init();
  return DayOfWeek_SATURDAY_instance;
}
function DayOfWeek_SUNDAY_getInstance() {
  static_init();
  return DayOfWeek_SUNDAY_instance;
}
//region block: exports
export {
  DayOfWeek_FRIDAY_getInstance as DayOfWeek_FRIDAY_getInstance3psmv5z0rk53n,
  DayOfWeek_MONDAY_getInstance as DayOfWeek_MONDAY_getInstance3u0uptycixs65,
  DayOfWeek_SATURDAY_getInstance as DayOfWeek_SATURDAY_getInstance2pwh8d7e3vqkf,
  DayOfWeek_SUNDAY_getInstance as DayOfWeek_SUNDAY_getInstance2wrn9wqlq8qv4,
  DayOfWeek_THURSDAY_getInstance as DayOfWeek_THURSDAY_getInstance2fa72o4vitekp,
  DayOfWeek_TUESDAY_getInstance as DayOfWeek_TUESDAY_getInstanceyj9r0qh47k6j,
  DayOfWeek_WEDNESDAY_getInstance as DayOfWeek_WEDNESDAY_getInstancewvb0t9y8yjce,
  get_entries as get_entries2ar453qbk297a,
  values as values3tr2ffumvy98e,
  DayOfWeek_0 as DayOfWeek2xlo40o03f5e,
  get_isoDayNumber as get_isoDayNumberrycq4er3aoh9,
};
//endregion

//# sourceMappingURL=DayOfWeek.mjs.map
